import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { colors, font, maxWidth } from "../styles/theme";
import { services } from "../data/services";
import ServiceIcon from "../components/ServiceIcon";

// Блок «Услуги» — сетка карточек. Карточка при наведении подсвечивает рамку (без прыжка/тени).
export default function ServicesSection() {
  return (
    <section id="uslugi" className="section-pad" style={{ background: "#fff", padding: "66px 22px", borderTop: "1px solid #eee" }}>
      <div style={{ maxWidth, margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", gap: 24, flexWrap: "wrap", marginBottom: 38 }}>
          <div>
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                fontFamily: font.display,
                fontWeight: 600,
                fontSize: 12,
                letterSpacing: ".16em",
                textTransform: "uppercase",
                color: colors.red,
              }}
            >
              <span style={{ width: 26, height: 2, background: colors.red, display: "inline-block" }} />
              Чем мы занимаемся
            </span>
            <h2 style={{ fontFamily: font.display, fontWeight: 700, fontSize: "clamp(2rem,4vw,3.2rem)", textTransform: "uppercase", margin: "14px 0 0", color: colors.ink }}>
              Услуги
            </h2>
          </div>
          <p style={{ maxWidth: 420, fontSize: 16, lineHeight: 1.55, color: "#5b6470", margin: 0 }}>
            Полный цикл работ по климату — от инженерного расчёта до сдачи объекта и сервисного обслуживания.
          </p>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(270px,1fr))", gap: 18 }}>
          {services.map((svc) => (
            <Card key={svc.num} svc={svc} />
          ))}
        </div>
      </div>
    </section>
  );
}

function Card({ svc }) {
  return (
    <div
      style={{
        border: "1px solid #e8eaee",
        borderRadius: 16,
        padding: "26px 24px",
        display: "flex",
        flexDirection: "column",
        gap: 15,
        background: "#fff",
        transition: "border-color .18s",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.borderColor = colors.red)}
      onMouseLeave={(e) => (e.currentTarget.style.borderColor = "#e8eaee")}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ width: 66, height: 66, borderRadius: 15, background: colors.redSoft, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <ServiceIcon name={svc.icon} size={36} color={colors.red} />
        </div>
        <span style={{ fontFamily: font.display, fontWeight: 700, fontSize: 32, color: "#eef0f3" }}>{svc.num}</span>
      </div>
      <h3 style={{ fontFamily: font.display, fontWeight: 600, fontSize: 24, textTransform: "uppercase", margin: 0, color: colors.ink }}>
        {svc.name}
      </h3>
      <p style={{ margin: 0, color: "#5b6470", fontSize: 14.5, lineHeight: 1.55, flex: 1 }}>{svc.desc}</p>
      <Link
        to={`/uslugi?svc=${svc.num}`}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 7,
          fontFamily: font.display,
          fontWeight: 600,
          fontSize: 13,
          letterSpacing: ".05em",
          textTransform: "uppercase",
          color: colors.red,
          textDecoration: "none",
        }}
      >
        Подробнее <ArrowRight size={15} color={colors.red} />
      </Link>
    </div>
  );
}
